import {Component, ViewEncapsulation} from '@angular/core';
import { CommonService } from 'src/app/_services/common.service';
@Component({
  selector: 'app-terms',
  templateUrl: './terms.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./terms.component.scss']
})
export class TermsComponent {

  isShowterms: boolean = false;
  currentLanguage = this.commonService.currentLanguage;
  constructor(public commonService: CommonService) {

  }

  showTerms(){
    this.isShowterms = true
  }

}
